module.exports = __webpack_public_path__ + "assets/4433d224069d9347afdcc0bef640bb14.png";